/** Fade duration (ms) — keep in sync with `status-toast-in` / `status-toast-out` in style.css. */
export const STATUS_TOAST_FADE_MS = 320;

/** @type {WeakMap<HTMLElement, { timeoutId?: ReturnType<typeof setTimeout>, onAnimationEnd?: (e: AnimationEvent) => void, fallbackId?: ReturnType<typeof setTimeout> }>} */
const toastState = new WeakMap();

function clearStatusToastTimer(mount) {
  var state = toastState.get(mount);
  if (!state || state.timeoutId == null) return;
  clearTimeout(state.timeoutId);
  state.timeoutId = undefined;
  toastState.set(mount, state);
}

function cancelStatusToastExit(mount) {
  var state = toastState.get(mount);
  if (!state) return;
  if (state.fallbackId != null) clearTimeout(state.fallbackId);
  if (state.onAnimationEnd && typeof mount.removeEventListener === "function") {
    mount.removeEventListener("animationend", state.onAnimationEnd);
  }
  var next = { timeoutId: state.timeoutId };
  toastState.set(mount, next);
  mount.classList.remove("status-toast--out");
}

function restartStatusToastIn(mount) {
  mount.style.animation = "none";
  void mount.offsetWidth;
  mount.style.animation = "";
}

/**
 * @param {HTMLElement | null | undefined} mount `#statusToast`
 */
export function hideStatusToast(mount) {
  if (!mount) return;
  clearStatusToastTimer(mount);
  if (mount.classList.contains("hidden") || mount.classList.contains("status-toast--out")) {
    return;
  }

  var done = false;
  var finish = function () {
    if (done) return;
    done = true;
    cancelStatusToastExit(mount);
    mount.classList.remove("status-toast--out");
    mount.classList.add("hidden");
  };

  var onAnimationEnd = function (event) {
    if (event.target !== mount || event.animationName !== "status-toast-out") return;
    finish();
  };

  var fallbackId = setTimeout(finish, STATUS_TOAST_FADE_MS + 32);
  var state = toastState.get(mount) || {};
  state.onAnimationEnd = onAnimationEnd;
  state.fallbackId = fallbackId;
  toastState.set(mount, state);
  if (typeof mount.addEventListener === "function") {
    mount.addEventListener("animationend", onAnimationEnd);
  }
  mount.classList.add("status-toast--out");
}

/**
 * @param {HTMLElement | null | undefined} mount `#statusToast`
 * @param {string | null | undefined} message
 * @param {number} [durationMs]
 */
export function showStatusToast(mount, message, durationMs) {
  if (!mount) return;
  clearStatusToastTimer(mount);
  cancelStatusToastExit(mount);

  if (!message) {
    hideStatusToast(mount);
    return;
  }

  mount.textContent = message;
  mount.classList.remove("hidden", "status-toast--out");
  restartStatusToastIn(mount);

  var ms = durationMs != null ? durationMs : 1800;
  var timeoutId = setTimeout(function () {
    hideStatusToast(mount);
  }, ms);
  var state = toastState.get(mount) || {};
  state.timeoutId = timeoutId;
  toastState.set(mount, state);
}
